exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-content {\r\n    padding-top: 10px;\r\n}\r\n\r\n.fa-disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/scopes/scopes.component.css
// module id = ../../../../../src/app/components/scopes/scopes.component.css
// module chunks = main